// import { Toast, Tooltip } from './_bootstrap';
import './_bootstrap.js';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

(function (once, $) {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

  Drupal.behaviors.bbanlamp = {
    attach: function (context, settings) {

      once('swiper-elements', '.swiper', context).forEach(el => {
        const opts = {};
        opts.modules = [Navigation, Pagination, Autoplay];
        opts.navigation = {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        };
        opts.loop = true;
        opts.autoplay = {
          delay: 5000,
          disableOnInteraction: false,
        };

        if (el.hasAttribute('data-swiper-pagination')) {
          if (el.getAttribute('data-swiper-pagination') === 'yes') {
            opts.pagination = {
              el: ".swiper-pagination",
              clickable: true
            }
          }
        }

        const swiper = new Swiper(el, opts);
      });

      const swiperNews = new Swiper('.views-news-slider .view-content', {
        modules: [Navigation, Pagination],
        createElements: true,
        slidesPerView: 1,
        slideClass: 'views-row',
        spaceBetween: '15px',
        navigation: {
          nextEl: ".news-button-next",
          prevEl: ".news-button-prev",
        },
        breakpoints: {
          540: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-pagination-news',
          clickable: true,
        },
      });

      const swiperCardCarousel = new Swiper('.block--card-carousel .field--name-field-card-items', {
        modules: [Navigation, Pagination],
        createElements: true,
        slidesPerView: 1,
        navigation: true,
        slideClass: 'field__item',
        autoplay: 2500,
        spaceBetween: 10,
        breakpoints: {
          540: {
            slidesPerView: 4
          }
        }
      });

      once('countdown-tick', '.countdown-event-countdown', context).forEach(function (el) {
        const timerSeconds = setInterval(function (el) {
          const elSec = el.querySelector('.seconds .value');
          const elMin = el.querySelector('.minutes .value');
          const elHour = el.querySelector('.hours .value');

          let val = elSec.textContent;

          if (val > 0) {
            val = val - 1;
          }
          else {
            val = 59;

            // Check minutes
            let valMin = elMin.textContent;
            valMin = (valMin > 0) ? valMin - 1 : 59;
            elMin.textContent = valMin;

            // Check hours
            let valHour = elHour.textContent;
            valHour = (valHour > 0) ? valHour - 1 : 24;
            elHour.textContent = valHour;
          }

          elSec.textContent = val;
        }, 1000, el);
      })

      once('judul-submenu', '.block--judul-submenu', context).forEach(function (el) {
        const pathName = window.location.pathname;
        const links = el.querySelectorAll('.field--name-field-links .field__item');
        links.forEach(function (elem) {
          const aTag = elem.querySelector('a');
          if (aTag) {
            const aTagPath = aTag.getAttribute('href');
            if (aTagPath === pathName) {
              aTag.classList.add('current-linkmenu');
            }
          }
        });
      });

      once('see-more', '.see-more', context)
        .forEach(function (el) {
        const blockParent = el.closest('.block');

        if (el && blockParent) {
          blockParent.appendChild(el);
        }
      });

      once('news-berita-thumbnail', '.gambar-berita', context).forEach(function (el) {

        const isNewsListing = el.closest('.views-news-listing');
        const isNewsLatest = el.closest('.views-news-latest');
        const isNewsPengawasan = el.closest('.views-news-pengawasan');
        let thumbAttr = ' width="480" height="320" alt="No thumbnail" ';
        if (isNewsListing) {
          thumbAttr = ' width="340" height="210" alt="No thumbnail" ';
        }
        else if(isNewsLatest || isNewsPengawasan) {
          thumbAttr = ' width="100" height="80" alt="No thumbnail" ';
        }

        if (el.getElementsByTagName('img').length === 0) {
          el.innerHTML = '<img src="/themes/custom/bbanlamp/build/assets/images/logo-white.webp" ' + thumbAttr + ' />';
        }
      });

      // Show dropdown on hover
      if (window.innerWidth > 720) {
        $('.dropdown').mouseover(function () {
          if($('.navbar-toggler').is(':hidden')) {
            $(this).addClass('show').attr('aria-expanded', 'true');
            $(this).find('.dropdown-menu').addClass('show');
          }
        }).mouseout(function () {
          if($('.navbar-toggler').is(':hidden')) {
            $(this).removeClass('show').attr('aria-expanded', 'false');
            $(this).find('.dropdown-menu').removeClass('show');
          }
        });

        // Go to the parent link on click
        $('.dropdown > a').click(function(){
          location.href = this.href;
        });

      }
    }
  }
})(once, jQuery);
